import { useEffect, useState } from "react";
import { apiMethod, RequestType } from "../../services/ApiRequest";
import { ENDPOINTS } from "../../services/EndPoint";
import TableComponent from "../TableComponent";

const WorkDoneBy = ({ filter }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        getData();
    }, [filter]);

    const header = [
        { value: "vendor.name", label: "Vendor" },
        { value: "occurrence", label: "Occurence" },
        { value: "total_expense", label: "Total Expense" },
        { value: "last_visit_date", label: "Last Visit Date" },
        { value: "currently_in_shop", label: "Currently In Shop" },
    ];
    const getData = async () => {
        const data = {
            date_type: filter
        }

        await apiMethod({
            method: RequestType.Post,
            auth: true,
            url: ENDPOINTS.workDoneBy,
            formData: false,
            body: data,
            onSuccess: (res) => {
                if (res?.data) {
                    setItems(res?.data?.results || []);
                }
            },
            onFailure: (error) => {
                console.error("Failed to fetch PM summary", error);
            },
        });
    };

    return (
        <div className="card_container">
            <TableComponent
                heading="Top Workshops:"
                icon={null}
                columns={header}
                data={items}
                currentPage={1}
            />
        </div>
    );
};

export default WorkDoneBy;
